import { Outlet } from 'react-router-dom';
// @mui
import { Container, Stack, useMediaQuery, useTheme } from '@mui/material';

// hooks
import { useAuthContext } from 'src/auth/useAuthContext';
// config
//
import SearchHeader from './SearchHeader';

// ----------------------------------------------------------------------

export default function SearchCompactLayout() {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const { isAuthenticated } = useAuthContext();

  return (
    <>
      <SearchHeader desktopHeight={56} />
      <Stack sx={{ height: '100vh' }}>
        <Container
          sx={{
            display: 'flex',
            flex: 1,
            maxWidth: '100% !important',
            justifyContent: 'center',
            alignItems: 'center',
            px: {
              xs: theme.spacing(2),
              sm: theme.spacing(2),
              md: theme.spacing(3),
              lg: theme.spacing(5),
            },
            py: {
              xs: theme.spacing(2),
              sm: theme.spacing(2),
              md: theme.spacing(3),
              lg: theme.spacing(5),
            },
            pt:
              isAuthenticated && isMdUp
                ? {
                    xs: `calc(56px + 64px + ${theme.spacing(3)})`, // header + nav
                    sm: `calc(56px + 64px + ${theme.spacing(3)})`,
                    md: `calc(56px + 64px + ${theme.spacing(3)})`,
                    lg: `calc(56px + 64px + ${theme.spacing(5)})`,
                  }
                : {
                    xs: `calc(56px + ${theme.spacing(3)})`,
                    sm: `calc(56px + ${theme.spacing(3)})`,
                    md: `calc(56px + ${theme.spacing(3)})`,
                    lg: `calc(56px + ${theme.spacing(5)})`,
                  },
          }}
          component="main"
        >
          <Outlet />
        </Container>
      </Stack>
    </>
  );
}
